import { generatedEffects } from '@get/store/effects';

export const effects = [...generatedEffects];
